import TextQuestionForm from './TextQuestionForm';

export default TextQuestionForm;
